import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { FaBehance } from "react-icons/fa";
import { HiOutlineDocumentText } from "react-icons/hi";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {props.isBehance && (
  <Button variant="primary" href={props.behanceLink} target="_blank">
    <FaBehance /> &nbsp; Behance
  </Button>
)}

        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {props.demoLinkLabel ?? "Demo"}
          </Button>
        )}

        {props.prdLink && (
          <Button
            variant="outline-light"
            href={props.prdLink}
            target="_blank"
            style={{ marginLeft: "10px", marginTop: "8px" }}
          >
            <HiOutlineDocumentText /> &nbsp; View PRD →
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
